import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ChangeDetectorRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-input-file-el',
  templateUrl: './input-file-el.component.html',
  styleUrls: ['./input-file-el.component.css']
})
export class InputFileElComponent implements OnInit, OnChanges {
  @ViewChild('fileInput', { static: true }) fileInput: any;
  @Output() fileSelectedEvent: EventEmitter<any> = new EventEmitter<FormData>();
  @Input() fileDataInput;
  @Input() dataField;
  @Input() dataInput;
  @Input() nomeFile: string;
  @Input() formGroup;
  @Input() existingFileName: string; // Nuovo input per il nome del file esistente

  accept: string = ''
  selectedFileName: string | File;

  constructor(private readonly cdr: ChangeDetectorRef) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['existingFileName']) {
      if (changes['existingFileName'].currentValue === null) {
        if (this.fileInput) this.fileInput.nativeElement.value = '';
        this.selectedFileName = null
      }
      this.createFileObj()
    }
    this.cdr.detectChanges()
  }

  ngOnInit() {
    console.log(this)
    this.createFileObj()
    if (this.fileDataInput && this.fileDataInput['fileAccepted'] && this.fileDataInput['fileAccepted'].length > 0) {
      if (Array.isArray(this.fileDataInput['fileAccepted'])) {
        this.accept = this.fileDataInput['fileAccepted'].join(',');
      }
    }
  }

  onFileSelected(event: Event) {

    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {

      const file = input.files[0];
      this.selectedFileName = file.name;

      //let fileSe
      this.fileSelectedEvent.emit(file);
      return

      const formData = new FormData();
      formData.append(this.dataField, file);
      formData.append('nomefile', this.nomeFile || file.name);


      // Debug: verifica i contenuti del formData
      this.logFormData(formData);
      this.fileSelectedEvent.emit(formData);
      const reader = new FileReader();
      reader.readAsDataURL(file);
    }
  }

  logFormData(formData: FormData) {
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
  }
  createFileObj() {
    this.selectedFileName = this.existingFileName || '';

    if (typeof this.selectedFileName == 'string') {

      if (this.selectedFileName !== '') {
        const byteString = atob(this.selectedFileName.split(',')[1]);

        const mimeType = this.selectedFileName.match(/data:(.*);base64/)[1] || 'application/octet-stream';

        //console.log('mimeType-->',mimeType);

        const filename = this.fileDataInput.customFileName ? this.fileDataInput.customFileName : this.dataInput['issuer']
        // Crea un array di byte
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        // Crea un Blob con i dati decodificati
        const blob = new Blob([ab], { type: mimeType });

        // Crea un oggetto File con il Blob
        const file = new File([blob], filename, { type: mimeType });

        this.selectedFileName = file.name;
      }
    } else if (typeof this.selectedFileName == 'object') {
      if (this.selectedFileName['name']) this.selectedFileName = this.selectedFileName['name'];
    }
  }
}